'use client'

import Script from 'next/script'
import type { JSX } from 'react'

export function Gtag(): JSX.Element {
  return (
    <>
      {process.env.NEXT_PUBLIC_GTAG_SCRIPT_ID && (
        <Script
          async
          src={`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GTAG_SCRIPT_ID}`}
        />
      )}

      <Script
        id="gtag-config"
        onLoad={() => {
          // Garantir que o script só execute após GTM estar carregado
          if (typeof window !== 'undefined') {
            // Script carregado com sucesso
          }
        }}
        strategy="afterInteractive"
      >
        {`
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${process.env.NEXT_PUBLIC_GA_ID ? process.env.NEXT_PUBLIC_GA_ID : process.env.NEXT_PUBLIC_GTM_ID!}', {
            transport_url: '${process.env.NEXT_PUBLIC_GTAG_TRANSPORT_URL!}',
            first_party_collection: true,
          });
          gtag('set', {'environment': 'Vitrine'});
        `}
      </Script>
    </>
  )
}
